import { Grid, Layout, Select } from 'antd';
import React, { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { CaseList } from './case-list/case-list';
import type {
  ApplicantCasesSectionLayoutContainerApplicantUserFieldsFragment
} from '../../../../generated';
import { CASE_TYPES } from '../../../../constants';

const { Content, Sider } = Layout;

interface SectionLayoutProps {
  handleCreateCredentialCase: () => Promise<void>;
  handleSendReportCase: () => Promise<void>;
  applicantUserData: ApplicantCasesSectionLayoutContainerApplicantUserFieldsFragment;
}

export const SectionLayout: React.FC<SectionLayoutProps> = (props) => {
  const { caseId } = useParams();
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;

  const handleCaseSelection = async (value: string) => {
    if (!value) {
      setSelectedValue(null);
      return;
    }
    setSelectedValue(value);
    setLoading(true);

    try {
      if (value === "credential-verification") {
        await props.handleCreateCredentialCase();
      } else if (value === "send-report") {
        await props.handleSendReportCase();
      }
    } catch (error) {
      console.error("Error during async operation:", error);
    } finally {
      setLoading(false);
      setSelectedValue(null);
    }
  };

  const mobileView = () => {
    return (
      <Layout>
        <Content style={{ padding: "10px 0px 0px 10px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          {!caseId && (
            <>
              <Select
                allowClear={true}
                placeholder={<span style={{ color: "black" }}>New Request</span>}
                style={{ width: "65%", marginBottom: "10px" }}
                value={selectedValue}
                loading={loading}
                onChange={handleCaseSelection}
                disabled={!props.applicantUserData.hasVerifiedIdentity}
              >
                {CASE_TYPES.map((caseType) => {
                  if (caseType.id === 'send-report' && !props.applicantUserData.hasVerifiedCredential) {
                    return <React.Fragment key={caseType.id}></React.Fragment>;
                  }
                  return (
                    <Select.Option key={caseType.id} value={caseType.id}>
                      {caseType.name}
                    </Select.Option>
                  );
                })}
              </Select>
              <CaseList />
            </>
          )}
          {caseId && <Outlet />}
        </Content>
      </Layout>
    );
  };

  if (isMobile) {
    return mobileView();
  }

  return (
    <Layout style={{ minHeight: '100%' }} hasSider>
      <Sider
        width={325}
        style={{
          padding: '20px 0px',
          textAlign: 'center',
          background: '#f0f2f5',
          boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.2)',
          zIndex: 2,
          position: "fixed", 
          height: "100%", 
        }}
        theme="light"
      >
        <Select
          allowClear={true}
          placeholder={<span style={{ color: 'black' }}>New Request</span>}
          style={{ width: '65%', marginBottom: '10px' }}
          value={selectedValue}
          loading={loading}
          onChange={handleCaseSelection}
          disabled={!props.applicantUserData.hasVerifiedIdentity}
        >
          {CASE_TYPES.map((caseType) => {
            if (caseType.id === 'send-report' && !props.applicantUserData.hasVerifiedCredential) {
              return <React.Fragment key={caseType.id}></React.Fragment>;
            }
            return (
              <Select.Option key={caseType.id} value={caseType.id}>
                {caseType.name}
              </Select.Option>
            );
          })}
        </Select>
        <CaseList />
      </Sider>
      <Content
        style={{
          marginLeft: 300,
          boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.1)',
          background: 'white',
          padding: '0 10px 10px',
          zIndex: 3,
          height: '100vh',
          overflowY: 'auto'
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
